<nav class="client-navbar" [class.boost-page]="isBoostPage">
	<img [src]="brandLogo" [alt]="'common.a11y.logo' | transloco" class="nav-logo" />

	<div class="nav-divider"></div>

	<a routerLink="/boost" routerLinkActive="active" class="nav-link">
		<lucide-icon name="Rocket" class="nav-icon"></lucide-icon>
		<span>{{ 'clientNavbar.boost' | transloco }}</span>
	</a>
	<a routerLink="/orders" routerLinkActive="active" class="nav-link">
		<lucide-icon name="ShoppingCart" class="nav-icon"></lucide-icon>
		<span>{{ 'clientNavbar.orders' | transloco }}</span>
	</a>

	<div class="nav-divider"></div>

	<button type="button" class="nav-profile" [attr.aria-label]="'common.a11y.profile' | transloco" (click)="openProfile()">
		<lucide-icon name="User" class="nav-icon" aria-hidden="true"></lucide-icon>
	</button>
</nav>
